// Extract a YouTube video ID from any common URL format (or return a plain ID).
// Supports: youtube.com/shorts/ID, youtu.be/ID, watch?v=ID, embed/ID, /v/ID, live/ID
export function getYouTubeId(input) {
  if (!input) return "";
  const s = String(input).trim();
  const m = s.match(
    /(?:youtube\.com\/(?:shorts\/|watch\?v=|embed\/|v\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/
  );
  if (m) return m[1];
  // already a bare id (no protocol / slashes / query)
  if (/^[A-Za-z0-9_-]{6,}$/.test(s)) return s;
  // last-resort: try to grab v= param
  const v = s.match(/[?&]v=([A-Za-z0-9_-]{6,})/);
  return v ? v[1] : s;
}
